import React, {
  ReactNode,
  createContext,
  useCallback,
  useContext,
} from 'react';

import { useState } from 'react';
import ErrorsLayout from './components/ErrosLayout/ErrorsLayout';
import ErrorItem from './components/Error/Error';

interface IError {
  id: number;
  message: string;
}

type TAddError = (message: string, aliveTime?: number) => void;

interface IProps {
  children?: ReactNode;
}

const ErrorContext = createContext<{ addError: TAddError } | undefined>(
  undefined
);

const ErrorsProvider = (props: IProps) => {
  const { children } = props;

  const [errors, setErrors] = useState<IError[]>([]);

  const removeError = (id: number) => {
    setErrors((prevError) => {
      return prevError.filter((error) => error.id !== id);
    });
  };

  const addError = useCallback((message: string, aliveTime = 10000) => {
    setErrors((prevError) => {
      const id = new Date().getTime() / 1000;
      setInterval(() => removeError(id), aliveTime);
      return [...prevError, { id, message }];
    });
  }, []);

  return (
    <ErrorContext.Provider value={{ addError }}>
      <ErrorsLayout>
        {errors.map((error) => (
          <ErrorItem
            key={error.id}
            message={error.message}
            handleOnClose={() => removeError(error.id)}
          />
        ))}
      </ErrorsLayout>

      {children}
    </ErrorContext.Provider>
  );
};

const useError = () => {
  const context = useContext(ErrorContext);

  if (context === undefined) {
    throw new Error('useError must be used within a ErrorsProvider');
  }

  return context;
};

export { ErrorsProvider, useError };
